
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-38807b20&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SearchComponent.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SearchComponent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-38807b20!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SearchComponent.vue"),
  /* scopeId */
  "data-v-38807b20",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/filter/SearchComponent.vue
// module id = 209
// module chunks = 2